export interface ITagsFilter {
  itemsByPage: number;
  pageIndex: number;
}

export type IItems = {
  id: number;
  tagNumber: string;
  vehiclePlate: string;
  locationDescription: string;
  createdAt: string;
  inactivatedAt: string;
  userName: string;
};

export type ITagForm = {
  id: number;
  isTagActive: boolean;
  tagNumber: string;
  vehiclePlate: string;
  locationDescription: string;
  ievNumber: string;
};

export type IResultCsvData = {
  totalProcessed: number;
  totalInserted: number;
  totalDuplicates: number;
  totalErrors: number;
  tagsErrors: Array<string>;
};

export type IVehicleTagInfo = {
  vehicleAlreadyHasTag: boolean;
  vehiclePlate: string;
  tagNumber: string;
  tagWasUpdatedWithPlate: boolean;
};

export interface ITagsState {
  isLoading: boolean;
  isLoadingTable: boolean;
  isLoadingEditDrawer: boolean;
  visibleDrawer: boolean;
  items?: Array<IItems>;
  totalItems: number;
  filter: ITagsFilter;
  searchFilter: string;
  editTag: ITagForm;
  visibleImportCsvModal: boolean;
  isLoadingImportCsvModal: boolean;
  dataCsv: File | null;
  resultCsvData: IResultCsvData;
  vehicleTagInfo: IVehicleTagInfo;
  vehicleAlreadyHasTagUserAccepted: boolean;
  tagWasInactive: boolean;
  tagHasInactiveUserAccepted: boolean;
  initialTagActiveState: boolean;
}

export const defaultState: ITagsState = {
  isLoading: false,
  isLoadingTable: false,
  visibleDrawer: false,
  editTag: {
    id: null,
    isTagActive: false,
    ievNumber: "",
    tagNumber: "",
    vehiclePlate: "",
    locationDescription: "",
  },
  vehicleTagInfo: {
    tagNumber: "",
    vehiclePlate: "",
    vehicleAlreadyHasTag: false,
    tagWasUpdatedWithPlate: false,
  },
  vehicleAlreadyHasTagUserAccepted: false,
  tagHasInactiveUserAccepted: false,
  tagWasInactive: false,
  initialTagActiveState: false,
  items: [],
  totalItems: 0,
  searchFilter: "",
  visibleImportCsvModal: false,
  isLoadingImportCsvModal: false,
  isLoadingEditDrawer: false,
  dataCsv: null,
  resultCsvData: {
    totalProcessed: 0,
    totalInserted: 0,
    totalDuplicates: 0,
    totalErrors: 0,
    tagsErrors: [],
  },
  filter: {
    itemsByPage: 10,
    pageIndex: 1,
  },
};
